import styled from "styled-components";

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.bg.general};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
